var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.showOverlay,"rounded":"sm"}},[(_vm.chartLoaded)?_c('Bar',{style:(_vm.styles),attrs:{"id":"chart","options":_vm.chartOptions,"data":_vm.chartData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }